import { Button, toast } from '@estac1/ui';
import { useMutation } from '@tanstack/react-query';
import { Eye } from 'lucide-react';
import { ApiError, api } from '../../lib/api.js';

const painelUrl = () =>
  (import.meta.env.VITE_PAINEL_URL as string | undefined) ??
  window.location.origin.replace('backoffice', 'painel');

/** A sessão vai no fragmento da URL: o navegador não manda o fragmento ao servidor. */
const toFragment = (payload: unknown) => {
  const bytes = new TextEncoder().encode(JSON.stringify(payload));
  const binary = Array.from(bytes, (b) => String.fromCharCode(b)).join('');
  return btoa(binary).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
};

/**
 * "Ver painel como o dono" (#668): abre o painel numa aba nova, só leitura,
 * por meia hora. A API recusa qualquer mudança e a abertura vai para a auditoria.
 */
export const ViewAsOwnerButton = ({ lotId }: { lotId: string }) => {
  const open = useMutation({
    mutationFn: () =>
      api.request<Record<string, unknown>>(`/v1/admin/clients/${lotId}/support-session`, {
        method: 'POST',
      }),
  });
  const onClick = () => {
    // A aba abre no clique; depois de esperar a API, o navegador bloquearia.
    const tab = window.open('', '_blank');
    if (tab) tab.opener = null;
    open.mutate(undefined, {
      onSuccess: (session) => {
        const url = `${painelUrl()}/support#s=${toFragment(session)}`;
        if (tab) tab.location.href = url;
        else window.location.assign(url);
      },
      onError: (err) => {
        tab?.close();
        toast.error(err instanceof ApiError ? err.message : 'Não foi possível abrir o painel.');
      },
    });
  };
  return (
    <Button variant="outline" size="sm" onClick={onClick} disabled={open.isPending}>
      <Eye className="h-4 w-4" aria-hidden="true" /> Ver painel como o dono
    </Button>
  );
};
